import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const PermisosContext = createContext(null);

// Permisos por defecto según rol (fallback si la API falla)
const PERMISOS_DEFAULT = {
  superadmin: {
    dashboard: true, clientes: true, planes: true, cartera: true,
    transacciones: true, ventas: true, reportes: true, tickets: true,
    agenda: true, equipos: true, caja: true, configuracion: true, usuarios: true,
    revendedores: true, equipos_red: true, proveedores_red: true, mikrotik: true,
    whatsapp: true, cotizaciones: true, catalogo: true, ayuda: true,
  },
  admin: {
    dashboard: true, clientes: true, planes: true, cartera: true,
    transacciones: true, ventas: true, reportes: true, tickets: true,
    agenda: true, equipos: true, caja: true, configuracion: true, usuarios: true,
    revendedores: true, equipos_red: true, proveedores_red: true, mikrotik: true,
    whatsapp: true, cotizaciones: true, catalogo: true, ayuda: true,
  },
  admin_old: {
    dashboard: true, clientes: true, planes: false, cartera: true,
    transacciones: true, ventas: true, reportes: false, tickets: true,
    agenda: true, equipos: false, caja: true, configuracion: false, usuarios: false,
  },
  tecnico: {
    dashboard: true, clientes: true, planes: false, cartera: false,
    transacciones: false, ventas: false, reportes: false, tickets: true,
    agenda: true, equipos: true, caja: false, configuracion: false, usuarios: false,
    ayuda: true,
  },
};

export const PermisosProvider = ({ children }) => {
  const { usuario } = useAuth();
  const [permisos, setPermisos] = useState({});
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!usuario) { setCargando(false); return; }
    const cargar = async () => {
      try {
        const { data } = await api.get('/api/usuarios/permisos');
        // Convertir a formato simple {modulo: boolean}
        const mapa = {};
        Object.keys(data).forEach(mod => { mapa[mod] = data[mod].puede_ver; });
        setPermisos(mapa);
      } catch {
        // Usar defaults si la API falla
        setPermisos(PERMISOS_DEFAULT[usuario?.rol] || PERMISOS_DEFAULT.admin_old || PERMISOS_DEFAULT.tecnico);
      } finally { setCargando(false); }
    };
    cargar();
  }, [usuario]);

  const puede = (modulo) => {
    if (usuario?.rol === 'superadmin') return true;
    return permisos[modulo] === true;
  };

  return (
    <PermisosContext.Provider value={{ permisos, puede, cargando }}>
      {children}
    </PermisosContext.Provider>
  );
};

export const usePermisos = () => useContext(PermisosContext);
